import styled from '@emotion/styled';
import { Input } from '@ui-components/neo.tax';
import { ReactComponent as CloseIcon } from '@ui-components/neo.tax/dist/icons/close.svg';
import { ReactComponent as SearchIcon } from '@ui-components/neo.tax/dist/icons/search.svg';

export const StyledInput = styled(Input)({
  flex: 1,
  '& .inline-trailing-content': {
    pointerEvents: 'auto',
  },
  '& input': {
    paddingRight: '2.5rem',
    paddingLeft: '2.75rem',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
  },
});

export const StyledSearchIcon = styled(SearchIcon)({
  height: '1.5rem',
});

export const StyledCloseIcon = styled(CloseIcon)({
  height: '1.5rem',
});
